<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column"
    fxLayoutGap="16px"
    [@routeAnimation]="true">
    <div class="form-loading-shade" *ngIf="isLoading" fxLayout="column"
        fxLayoutAlign="center center"
        fxLayoutGap="10px">
        <ngx-spinner bdColor="rgb(255,255,255)" [name]="tableName"
            size="default" color="#66bb6a" type="ball-fall"
            [fullScreen]="false">
            <p style="color: black"> Loading applications... </p>
        </ngx-spinner>

    </div>
    <div fxLayout="column">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)"
                placeholder="Filter">
        </mat-form-field>
    </div>
    <div fxLayout="column" class="mat-elevation-z8 table-container">
        <mat-table #table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.4;">
                </mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex-grow: 0.4;">
                    <mat-checkbox *ngIf="isVisible(row)"
                        (click)="$event.stopPropagation()"
                        (change)="$event ? formDataChecked(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="requestNo">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Request No
                </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.requestNo}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="grantName">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Grant Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{row.grantName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="PEName">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Project/ Event Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{row.formName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="formName">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Request Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{row.formName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="projectName">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Project Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{row.formName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="eventName">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Event Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{row.formName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="orgName">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Organization Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{row.orgName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="subsection">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Tax-Exempt Status </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    {{ getTaxExemptStatus(row.subsection)}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dateRequest">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Request Date
                </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.dateRequest | date:
                    'MM-dd-yyyy'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="amount">
                <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef
                    mat-sort-header> Amount </mat-header-cell>
                <mat-cell style="flex-grow: 1;" *matCellDef="let row">
                    {{row.amount}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell style="flex-grow: 1.3;" *matHeaderCellDef
                    mat-sort-header> Status </mat-header-cell>
                <mat-cell style="flex-grow: 1.3;" *matCellDef="let row"
                    [ngClass]="getStatusClass(row.status)">
                    {{row.status}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="statusAdmin">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Admin Status
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"
                    [ngClass]="getStatusClass(row.statusDescrAdmin)">
                    {{row.statusDescrAdmin}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="statusApproval">
                <mat-header-cell style="flex-grow: 1.5;" *matHeaderCellDef
                    mat-sort-header> Status </mat-header-cell>
                <mat-cell style="flex-grow: 1.5;" *matCellDef="let row"
                    style="margin:
                    5px 0px 5px 0px;"
                    [ngClass]="getStatusClass(row.statusDescrAdmin)">
                    {{row.statusDescrAdmin}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="approverName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Name
                </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.approverName}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="title">
                <mat-header-cell style="flex-grow: 1.75;" *matHeaderCellDef
                    mat-sort-header> Title </mat-header-cell>
                <mat-cell style="flex-grow: 1.75;" *matCellDef="let row">
                    {{row.title}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="comment">
                <mat-header-cell style="flex-grow: 1.75;" *matHeaderCellDef
                    mat-sort-header> Comment </mat-header-cell>
                <mat-cell style="flex-grow: 1.75;" *matCellDef="let row">
                    {{row.comment}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="print">
                <mat-header-cell style="flex-grow: 0.5;" *matHeaderCellDef
                    mat-sort-header></mat-header-cell>
                <mat-cell style="flex-grow: 0.5;" *matCellDef="let row">
                    <button mat-icon-button matTooltip="Save application as PDF"
                        matTooltipShowDelay="1000"
                        (click)="onPrint(row)">
                        <mat-icon color="primary">print</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="view">
                <mat-header-cell style="flex-grow: 0.5;" *matHeaderCellDef></mat-header-cell>
                <mat-cell style="flex-grow: 0.5;" *matCellDef="let row">
                    <button mat-icon-button matTooltip="Open request"
                        matTooltipShowDelay="1000"
                        (click)="selectRow(row)">
                        <mat-icon color="primary">login</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"
                (click)="selectRow(row)">
            </mat-row>
        </mat-table>
    </div>
    <div fxLayout="column" style="display: flex;">
        <mat-toolbar>
            <mat-toolbar-row>
                <div *ngIf="this.selection.selected.length">
                    <button mat-raised-button class="fab" color="warn"
                        *ngIf="this.isIntSelected"
                        (click)="DeleteFormInt()">Delete</button>
                    <button mat-raised-button class="fab" color="primary"
                        *ngIf="!this.isIntSelected"
                        (click)="ApproveRejectFormExtList('Approve')">Approve</button>
                    <button mat-raised-button class="fab" color="warn"
                        *ngIf="!this.isIntSelected"
                        (click)="ApproveRejectFormExtList('Reject')">Reject</button>
                    <button mat-raised-button class="fab" color="warn"
                        (click)="ClearSelection()">Clear
                        Selection</button>
                </div>
                <span class="example-spacer"></span>
                <mat-paginator class="paginator" [pageSizeOptions]="[5, 10, 25,
                    100, 125, 150, 175, 200]">
                </mat-paginator>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
</div>